import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App/App';

import { BrowserRouter as Router} from "react-router-dom";

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
<Router>
  <App />
</Router>
, document.getElementById('app-component'));

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js